import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StatusHandler } from '../../../components'
import { fetchEvents, fetchFeaturedEvents } from '../../../features/events/slice'
import { useViewport } from '../../../utils'
import { MainContent, MainContentMobile } from '.'
import * as pageConfig from '../config'
import { eventsActions as actions } from '../../../features/events/slice'

const PageContent = () => {
  const dispatch = useDispatch()
  const { isDesktop } = useViewport()
  const {data, status, error, query} = useSelector(state => state.events)
  const defaultFeaturedItems = useSelector(state => state.events.data_featured)

  // request data to FEATURED events API
  React.useEffect(() => {
    dispatch(fetchFeaturedEvents())
    // eslint-disable-next-line
  }, [])

  return (
    <StatusHandler
      status={status}
      error={error}
      onRetry={() => dispatch(fetchEvents())}
    >
      {
        isDesktop ? (
          <MainContent
            events={data}
            query={query}
            pageConfig={pageConfig}
            actions={actions}
            defaultFeaturedItems={defaultFeaturedItems}
          />
        ) : (
          <MainContentMobile
            events={data}
            query={query}
            pageConfig={pageConfig}
            actions={actions}
            defaultFeaturedItems={defaultFeaturedItems}
          />
        )
      }
    </StatusHandler>
  )
}

export { PageContent }
